module.exports = {
	"landing": {},
	"home": {
		"en": {
			"name": "HOME",
			"url": "/en",
			"mobileUrl": "/m/en"
		},
		"tc": {
			"name": "主頁",
			"url": "/tc",
			"mobileUrl": "/m/tc"
		},
		"sc": {
			"name": "主页",
			"url": "/sc",
			"mobileUrl": "/m/sc"
		},
		"imageUrl": "/button/logo.png",
		"id": "MENU-HOME"
	},
	"gallery": {
		"en": {
			"name": "GALLERY",
			"url": "/en/gallery",
			"mobileUrl": "/m/en/gallery",
			"titleUrl": "/title/gallery.png"
		},
		"tc": {
			"name": "相集",
			"url": "/tc/gallery",
			"mobileUrl": "/m/tc/gallery"
		},
		"sc": {
			"name": "相集",
			"url": "/sc/gallery",
			"mobileUrl": "/m/sc/gallery"
		},
		"imageUrl": "/button/gallery.png",
		"id": "MENU-GALLERY"
	},
	"announcement": {
		"en": {
			"name": "ANNOUNCEMENT",
			"url": "/en/announcement",
			"mobileUrl": "/m/en/announcement",
			"titleUrl": "/title/announcement.png"
		},
		"tc": {
			"name": "最新消息",
			"url": "/tc/announcement",
			"mobileUrl": "/m/tc/announcement"
		},
		"sc": {
			"name": "最新消息",
			"url": "/sc/announcement",
			"mobileUrl": "/m/sc/announcement"
		},
		"imageUrl": "/button/announcement.png",
		"id": "MENU-ANNOUNCEMENT"
	},
	"salesBrochure": {
		"en": {
			"name": "SALES BROCHURE",
			"url": "/en/sales-brochure",
			"mobileUrl": "/m/en/sales-brochure",
			"titleUrl": "/title/sales-brochure.png"
		},
		"tc": {
			"name": "售樓說明書",
			"url": "/tc/sales-brochure",
			"mobileUrl": "/m/tc/sales-brochure"
		},
		"sc": {
			"name": "售楼说明书",
			"url": "/sc/sales-brochure",
			"mobileUrl": "/m/sc/sales-brochure"
		},
		"imageUrl": "/button/sales-brochure.png",
		"id": "MENU-SALES-BROCHURE"
	},
	"priceList": {
		"en": {
			"name": "PRICE LIST",
			"url": "/en/price-list",
			"mobileUrl": "/m/en/price-list",
			"titleUrl": "/title/price-list.png"
		},
		"tc": {
			"name": "價單",
			"url": "/tc/price-list",
			"mobileUrl": "/m/tc/price-list"
		},
		"sc": {
			"name": "价单",
			"url": "/sc/price-list",
			"mobileUrl": "/m/sc/price-list"
		},
		"imageUrl": "/button/price-list.png",
		"id": "MENU-PRICE-LIST"
	},
	"salesArrangements": {
		"en": {
			"name": "SALES<br>ARRANGEMENTS",
			"url": "/en/sales-arrangements",
			"mobileUrl": "/m/en/sales-arrangements",
			"titleUrl": "/title/sales-arrangements.png"
		},
		"tc": {
			"name": "銷售安排",
			"url": "/tc/sales-arrangements",
			"mobileUrl": "/m/tc/sales-arrangements"
		},
		"sc": {
			"name": "销售安排",
			"url": "/sc/sales-arrangements",
			"mobileUrl": "/m/sc/sales-arrangements"
		},
		"imageUrl": "/button/sales-arrangements.png",
		"id": "MENU-SALES-ARRANGEMENTS"
	},
	"registerOfTransactions": {
		"en": {
			"name": "REGISTER OF<br>TRANSACTIONS",
			"url": "/en/register-of-transactions",
			"mobileUrl": "/m/en/register-of-transactions",
			"titleUrl": "/title/register-of-transactions.png"
		},
		"tc": {
			"name": "成交記錄冊",
			"url": "/tc/register-of-transactions",
			"mobileUrl": "/m/tc/register-of-transactions"
		},
		"sc": {
			"name": "成交记录册",
			"url": "/sc/register-of-transactions",
			"mobileUrl": "/m/sc/register-of-transactions"
		},
		"imageUrl": "/button/register-of-transactions.png",
		"id": "MENU-REGISTER-OF-TRANSACTIONS"
	},
	"deedOfMutualCovenant": {
		"en": {
			"name": "DEED OF<br>MUTUAL COVENANT",
			"url": "/en/deed-of-mutual-covenant",
			"mobileUrl": "/m/en/deed-of-mutual-covenant",
			"titleUrl": "/title/deed-of-mutual-covenant.png"
		},
		"tc": {
			"name": "公契",
			"url": "/tc/deed-of-mutual-covenant",
			"mobileUrl": "/m/tc/deed-of-mutual-covenant"
		},
		"sc": {
			"name": "公契",
			"url": "/sc/deed-of-mutual-covenant",
			"mobileUrl": "/m/sc/deed-of-mutual-covenant"
		},
		"imageUrl": "/button/deed-of-mutual-covenant.png",
		"id": "MENU-DEED-OF-MUTUAL-COVENANT"
	},
	"aerialPhotograph": {
		"en": {
			"name": "AERIAL<br>PHOTOGRAPH",
			"url": "/en/aerial-photograph",
			"mobileUrl": "/m/en/aerial-photograph",
			"titleUrl": "/title/aerial-photograph.png"
		},
		"tc": {
			"name": "鳥瞰照片",
			"url": "/tc/aerial-photograph",
			"mobileUrl": "/m/tc/aerial-photograph"
		},
		"sc": {
			"name": "鸟瞰照片",
			"url": "/sc/aerial-photograph",
			"mobileUrl": "/m/sc/aerial-photograph"
		},
		"imageUrl": "/button/aerial-photograph.png",
		"id": "MENU-AERIAL-PHOTOGRAPH"
	},
	"tenderDocuments": {
		"en": {
			"name": "TENDER DOCUMENTS",
			"url": "/en/tender-documents",
			"mobileUrl": "/m/en/tender-documents",
			"titleUrl": "/title/tender-documents.png"
		},
		"tc": {
			"name": "招標文件",
			"url": "/tc/tender-documents",
			"mobileUrl": "/m/tc/tender-documents"
		},
		"sc": {
			"name": "招标文件",
			"url": "/sc/tender-documents",
			"mobileUrl": "/m/sc/tender-documents"
		},
		"imageUrl": "/button/tender-documents.png",
		"id": "TENDER-DOCUMENTS"
	},
	"p2": {
		"en": {
			"url": "/p2/en"
		},
		"tc": {
			"url": "/p2/tc"
		},
		"sc": {
			"url": "/p2/sc"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/route.json
// module id = 10
// module chunks = 0